import { Group } from "../models/group.model";
import * as _ from "underscore";
import { GROUP_TYPE } from "./member.helper";
import { MEMBER_TYPE } from "./member.helper";

import * as moment from "moment";

import PhoneNumberHelper from "./phoneNumber.helper";
import MemberHelper from "./member.helper";

export default class ValidatorHelper {
    static assumeIsPhoneNumber(str) {
        if (_.isEmpty(str)) {
            return false;
        }

        str = str.replace(/\+/g, "");
        str = str.replace(/-/g, "");
        str = str.replace(/ /g, "");

        return !isNaN(Number(str));
    }
    static assumeIsEmail(str) {
        if (_.isEmpty(str)) {
            return false;
        }

        return str.indexOf("@") > -1;
    }
    static isValidCellPhoneNumber(phoneNumber, regionCode: String = undefined) {
        var phoneNumberWithCountryCode;

        if (phoneNumber.length < 5) {
            return false;
        }

        if (phoneNumber.indexOf("+") !== 0) {
            phoneNumberWithCountryCode = PhoneNumberHelper.getPhoneNumberWithCountryCode(phoneNumber, regionCode);
            // if (!phoneNumberWithCountryCode || !phoneUtils.isValidNumberForRegion(phoneNumber, regionCode)) {
            //     return false;
            // }
        } else {
            //TODO:
            // if (!phoneUtils.isValidNumber(phoneNumber)) {
            //     return false;
            // }
            phoneNumberWithCountryCode = phoneNumber;
        }

        if (!phoneNumberWithCountryCode) {
            return false;
        }

        var numberType;

        var regionCodeForNumber = PhoneNumberHelper.getRegionCodeForNumber(phoneNumberWithCountryCode);

        if (regionCodeForNumber !== null) {
            //            numberType = phoneUtils.getNumberType(phoneNumberWithCountryCode);
        } else {
            // Is valid phone number but could not find regionCodeForNumber
            return true;
        }

        return numberType == "MOBILE" || numberType == "FIXED_LINE_OR_MOBILE" || numberType == "PERSONAL_NUMBER";
    }
    static isValidEmail(email) {
        if (_.isEmpty(email)) {
            return false;
        }

        email = email.trim();

        var re =
            /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return re.test(email);
    }

    static isPhoneValid = (phone) => {
        if (typeof phone !== "string" || !phone) {
            return false;
        }
        const numberWithoutPlus = phone.slice(1);

        const plusMatch = phone.match(/([+])/g);

        if (plusMatch && plusMatch.length > 1) {
            return false;
        }

        if (!numberWithoutPlus.match(/^[0-9]*$/)) {
            return false;
        }

        return phone[0] === "+";
    };
}
